import { T } from "../../../../util/t";
import { HelpTooltip } from "../../../../elements/helpTooltip";
import { Link } from "@mui/material";

export const DocsToSignHelpTooltip = () =>
    <HelpTooltip>
        <T>Upload your document, then drag & drop signing fields where athletes/guardians need to sign. <Link href="https://support.liveheats.com/hc/en-us/articles/16961286432660" underline="always" variant="inherit" target="_blank">More info</Link></T>
    </HelpTooltip>;
